<template>
    <div>
        <!-- <div class="mynav">
            <div class="logoDiv"><a href="./"><img id="logo" src="../assets/logo.png"></a></div>
            <div class="navbar">
            <ul>
                <li><router-link to="./">首页</router-link></li>
                <li><router-link to="./product">产品</router-link></li>
                <li><router-link to="./video">视频教程</router-link></li>
                <li><router-link to="./aboutUs">关于我们</router-link></li>
                <li><router-link to="./news">新闻动态</router-link></li>
                <li><a href="https://shop457421467.taobao.com/" target="_blank">音书小店</a></li>
                <li><a href="https://pro.voibook.com" target="_blank">字幕速记</a></li>
                <li><a href="javascript:void(0)" style="display:none;">&#9776;</a></li>
            </ul>
            </div>
        </div> -->
        <div class="container">
            <div id="want">
                <div class="tab">
                    <button class="more" id="defaultShow" @click="showMore($event)">社会招聘</button>
                    <div class="panel">
                        <span class="tablinks" @click="showInfo($event, 'hardware')" id="openhh">硬件架构</span>
                        <span class="tablinks" @click="showInfo($event, 'iOS')">iOS开发</span>
                        <span class="tablinks" @click="showInfo($event, 'android')">安卓开发</span>
                        <span class="tablinks" @click="showInfo($event, 'android')">视觉开发</span>
                    </div>
                    <button class="more" @click="showMore($event)">
                        校园招聘
                    </button>
                    <div class="panel">
                        <span class="tablinks" @click="showInfo($event, 'hardware')" id="openhh">运营实习</span>
                        <span class="tablinks" @click="showInfo($event, 'iOS')">运营策划</span>
                        <span class="tablinks" @click="showInfo($event, 'android')">公关实习</span>
                        <span class="tablinks" @click="showInfo($event, 'android')">手语翻译实习</span>
                    </div>
                </div>

                <div id="hardware" class="tabcontent">
                    <span>招聘岗位 recruitment post</span><br>
                    <div>
                        <p>硬件架构师</p>
                        <span class="subText">工作职责：</span>
                        <div class="need">
                            <p v-for="mywork in yourWork" :key="mywork.work">{{mywork.idx}}. {{mywork.work}}</p>
                        </div>
                        <span class="subText">能力要求：</span>
                        <div class="need">
                            <p v-for="(myab,index) in ability" :key="index">{{myab.ab}}</p>
                        </div>
                        <span class="subText">工作地点：</span>
                        <div class="need">
                            <p>广州</p>
                        </div>
                        <span class="subText">简历投递：</span>
                        <div class="need">
                            <p>jobs@voibook.com</p>
                        </div>
                    </div>
                </div>

                <div id="iOS" class="tabcontent">
                    <span>招聘岗位 recruitment post</span><br>
                    <div>
                        <p>iOS开发工程师</p>
                        <span class="subText">工作职责：</span>
                        <div class="need">
                            <p v-for="mywork in yourWork" :key="mywork.work">{{mywork.idx}}. {{mywork.work}}</p>
                        </div>
                        <span class="subText">能力要求：</span>
                        <div class="need">
                            <p v-for="(myab,index) in ability" :key="index">{{myab.ab}}</p>
                        </div>
                        <span class="subText">工作地点：</span>
                        <div class="need">
                            <p>广州</p>
                        </div>
                        <span class="subText">简历投递：</span>
                        <div class="need">
                            <p>jobs@voibook.com</p>
                        </div>
                    </div>
                </div>

                <div id="android" class="tabcontent">
                    <span>招聘岗位 recruitment post</span><br>
                    <div>
                        <p>Android开发工程师</p>
                        <span class="subText">工作职责：</span>
                        <div class="need">
                            <p v-for="mywork in yourWork" :key="mywork.work">{{mywork.idx}}. {{mywork.work}}</p>
                        </div>
                        <span class="subText">能力要求：</span>
                        <div class="need">
                            <p v-for="(myab,index) in ability" :key="index">{{myab.ab}}</p>
                        </div>
                        <span class="subText">工作地点：</span>
                        <div class="need">
                            <p>广州</p>
                        </div>
                        <span class="subText">简历投递：</span>
                        <div class="need">
                            <p>jobs@voibook.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
        <customer-service />
    </div>
</template>

<script>
import CustomerService from '@/components/CustomerService.vue'

export default {
    name: 'joinPage',
  components: {
    CustomerService
  },
    data () {
        return {
            yourWork: [
                {
                    idx: '1',
                    work: '负责智能硬件结构设计及实施'
                },
                {
                    idx: '2',
                    work: '和供应商合作，负责常用元器件的选型、优化设计、验证'
                },
                {
                    idx: '3',
                    work: '跟踪和处理模具、成型、机加工、烤漆、雷射焊接及组装等生产问题'
                },
                {
                    idx: '4',
                    work: '负责供应链订单的管理，库存管理，稀缺物料的管控'
                },
                {
                    idx: '5',
                    work: '管理产品研发、试产、量产等各阶段进度'
                }
            ],
            ability: [
                {
                    ab: '1. 机械/电子/自动化相关专业，五年以上移动通信终端产品结构设计经验、有成功量产的案例'
                },
                {
                    ab: '2. 熟悉产品环境及可靠性测试规范，熟悉产品外观品质标准'
                },
                {
                    ab: '3. 熟悉精密塑胶件、钣金件、压铸件、橡胶件、五金件等各类零部件的生产制造工艺，对塑胶模和压铸模有一定了解，跟模和整机组装现场支持经验丰富'
                },
                {
                    ab: '4. 熟悉蓝牙/光学/声学/热/EMC/ESD/设计要求'
                }
            ]
        }
    },
    methods: {
        showInfo: function (evt, infoDetail) {
            var i, tabcontent, tablinks
            tabcontent = document.getElementsByClassName('tabcontent')
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = 'none'
            }
            tablinks = document.getElementsByClassName('tablinks')
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(' active', '')
            }
            document.getElementById(infoDetail).style.display = 'block'
            evt.currentTarget.className += ' active'
        },
        showMore: function (evt) {
            var acc = document.getElementsByClassName('more')
            var i

            for (i = 0; i < acc.length; i++) {
                acc[i].className = acc[i].className.replace(' active1', '')
            }
            // evt.currentTarget.className += 'active1';
            var panel = evt.currentTarget.nextElementSibling
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px'
            }
        }
    },
    mounted () {
        document.getElementById('openhh').click()
        document.getElementById('defaultShow').click()
    }
}
</script>

<style scoped>
@import './join.css';
</style>



// WEBPACK FOOTER //
// src/pages/Join.vue